import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchLink } from 'redux/links/actions';

import { Checkbox } from 'semantic-ui-react';

import './CommonLinkPinterestOptions.css';

function CommonLinkPinterestOptions(props) {
    const { linkItem, patchLink } = props;
    const { t } = useTranslation();

    const [currentMode, setCurrentMode] = useState(linkItem.is_embed ? 'embed' : 'link');

    const onPatch = value => {
        const form = new FormData();
        form.append('is_embed', value);
        patchLink(linkItem.id, form);
    };

    const onCheckboxChange = type => {
        if (type === 'link') {
            if (currentMode === 'link') {
                setCurrentMode('embed');
                onPatch(true);
            } else {
                setCurrentMode('link');
                onPatch(false);
            }
        } else if (type === 'embed') {
            if (currentMode === 'embed') {
                setCurrentMode('link');
                onPatch(false);
            } else {
                setCurrentMode('embed');
                onPatch(true);
            }
        }
    };

    return (
        <div className="common-link-pinterest-options__component">
            <div className="title">
                {t("Choose to display a Pinterest preview on your HeyLink.me or link off to Pinterest")}
            </div>

            <div className="checkbox-wrapper">
                <Checkbox
                    key={`pinterest-option-link-checkbox-key-${linkItem.id}`}
                    id={`pinterest-option-link-checkbox-id-${linkItem.id}`}
                    label={t("Link off to Pinterest")}
                    checked={currentMode === 'link'}
                    onChange={() => onCheckboxChange('link')}
                />
            </div>

            <div className="checkbox-wrapper">
                <Checkbox
                    key={`pinterest-option-embed-checkbox-key-${linkItem.id}`}
                    id={`pinterest-option-embed-checkbox-id-${linkItem.id}`}
                    label={t("Display this video on my HeyLink.me")}
                    checked={currentMode === 'embed'}
                    onChange={() => onCheckboxChange('embed')}
                />
            </div>
        </div>
    );
}

CommonLinkPinterestOptions.propTypes = {
    patchLink: PropTypes.func.isRequired,
    linkItem: PropTypes.object.isRequired,
};

export default connect(
    null,
    {
        patchLink,
    }
) (CommonLinkPinterestOptions);
